/* import __COLOCATED_TEMPLATE__ from './sub-category-item.hbs'; */
import CategoryListItem from "discourse/components/category-list-item";

export default CategoryListItem.extend({});
